import { BoostProvider, BoostTask } from '../types/boost';
import { PROVIDERS } from '../types/boost';

declare global {
  interface Window {
    initCdTma: (config: { id: number }) => Promise<boolean>;
    showCdTma: () => Promise<boolean>;
  }
}

const isDev = process.env.NODE_ENV === 'development';

export class OnClickABoostProvider implements BoostProvider {
  private isInitialized = false;
  private initializationPromise: Promise<void> | null = null;

  getName(): string {
    return PROVIDERS.ONCLICK;
  }

  private async initialize(): Promise<void> {
    if (this.isInitialized) return;
    if (this.initializationPromise) return this.initializationPromise;

    this.initializationPromise = new Promise((resolve, reject) => {
      if (!window.initCdTma) {
        reject(new Error('OnClickA SDK не найден'));
        return;
      }

      window
        .initCdTma({ id: 6058906 })
        .then((success) => {
          if (success) {
            this.isInitialized = true;
            resolve();
          } else {
            reject(new Error('Не удалось инициализировать OnClickA'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

    return this.initializationPromise;
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    try {
      await this.initialize();

      const tasks = [
        {
          id: '6058906',
          title: 'Показать рекламу',
          description: 'Просмотр рекламы OnClickA',
          provider: PROVIDERS.ONCLICK,
          onClick: async (): Promise<
            'success' | 'user_cancelled' | 'ads_not_found'
          > => {
            try {
              if (!window.showCdTma) {
                console.error('OnClickA: showCdTma не найден');
                return 'ads_not_found';
              }

              const result = await window.showCdTma();
              if (!result) {
                console.error('OnClickA: показ рекламы не удался');
                return 'ads_not_found';
              }

              return 'success';
            } catch (error) {
              console.error('Ошибка показа рекламы OnClickA:', error);
              return 'ads_not_found';
            }
          },
        },
      ];
      console.log('[OnClickABoostProvider] Доступные задания:', tasks);
      return tasks;
    } catch (error) {
      console.error('Ошибка получения заданий OnClickA:', error);
      return [];
    }
  }

  resetError(): void {
    this.isInitialized = false;
    this.initializationPromise = null;
  }
}
